module.exports = __webpack_public_path__ + "static/img/10.4a861b22.png";